<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="卡号" prop="bankNo">
          <el-input v-model="dataForm.bankNo" placeholder="卡号"></el-input>
      </el-form-item>
          <el-form-item label="所属银行" prop="bank">
          <el-input v-model="dataForm.bank" placeholder="所属银行"></el-input>
      </el-form-item>
          <el-form-item label="支行" prop="branch">
          <el-input v-model="dataForm.branch" placeholder="支行"></el-input>
      </el-form-item>
          <el-form-item label="省" prop="province">
          <el-input v-model="dataForm.province" placeholder="省"></el-input>
      </el-form-item>
          <el-form-item label="市" prop="city">
          <el-input v-model="dataForm.city" placeholder="市"></el-input>
      </el-form-item>
          <el-form-item label="区" prop="area">
          <el-input v-model="dataForm.area" placeholder="区"></el-input>
      </el-form-item>
      <el-form-item label="添加时间" prop="addTime">
          <!-- <el-input v-model="dataForm.addTime" placeholder="添加时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.addTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="添加IP" prop="addIp">
          <el-input v-model="dataForm.addIp" placeholder="添加IP"></el-input>
      </el-form-item>
          <el-form-item label="0：关闭，1：启用" prop="status">
          <el-input v-model="dataForm.status" placeholder="0：关闭，1：启用"></el-input>
      </el-form-item>
          <el-form-item label="银行对应图片URL" prop="picPath">
          <el-input v-model="dataForm.picPath" placeholder="银行对应图片URL"></el-input>
      </el-form-item>
          <el-form-item label="银行编号" prop="bankCode">
          <el-input v-model="dataForm.bankCode" placeholder="银行编号"></el-input>
      </el-form-item>
          <el-form-item label="卡类型" prop="cardType">
          <el-input v-model="dataForm.cardType" placeholder="卡类型"></el-input>
      </el-form-item>
          <el-form-item label="卡属性" prop="cardAttribute">
          <el-input v-model="dataForm.cardAttribute" placeholder="卡属性"></el-input>
      </el-form-item>
          <el-form-item label="银行预留手机号（可能有别于注册手机号）" prop="phoneNo">
          <el-input v-model="dataForm.phoneNo" placeholder="银行预留手机号（可能有别于注册手机号）"></el-input>
      </el-form-item>
          <el-form-item label="钱包系统卡ID" prop="cardId">
          <el-input v-model="dataForm.cardId" placeholder="钱包系统卡ID"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        bankNo: '',
        bank: '',
        branch: '',
        province: '',
        city: '',
        area: '',
        addTime: '',
        addIp: '',
        status: '',
        picPath: '',
        bankCode: '',
        cardType: '',
        cardAttribute: '',
        phoneNo: '',
        cardId: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bank: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        branch: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        province: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        city: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        area: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addIp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        picPath: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cardType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cardAttribute: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        phoneNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cardId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slaccountbank/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slaccountbank/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
